import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Typography, Divider, IconButton } from '@mui/material';
import { styled } from '@mui/system';

const ModalTemplate = ({ isOpen, onClose, title, children }: any) => {
    const Paper = styled('div')(({ theme }: any) => ({
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(3),
        outline: 'none',
        minWidth: 300,
        borderRadius: '4px',
        maxWidth: 600,
        position: 'relative',
    }));

    const Title = styled(Typography)(({ theme }) => ({
        marginTop: 0,
        color: theme.palette.text.primary,
    }));

    const DividerStyled = styled(Divider)(({ theme }) => ({
        margin: theme.spacing(2, 0),
    }));

    const CloseButton = styled(IconButton)(({ theme }) => ({
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    }));

    return (
        <Modal open={isOpen} onClose={onClose} style={{position: 'absolute', top: '30%', left: '30%'}}>
            <Paper>
                <CloseButton onClick={onClose}>
                    <CloseIcon />
                </CloseButton>
                <Title variant="h6">
                    {title}
                </Title>
                <DividerStyled />
                {children}
            </Paper>
        </Modal>
    );
};

export default ModalTemplate;
